import React, { useState } from 'react'
import { MDBIcon } from 'mdb-react-ui-kit';

function ViewAnnouncement({ announcements, handleClose }) {
  
    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

    return (
        <div>
      
            <div className="dashboard-announcements-sidebar">
                <div className="dashboard-sidebar-header">
                    <h5 className='m-0'>Announcements</h5>
                    <button
                        className="dashboard-close-sidebar"
                        onClick={() => {
                            handleClose();
                            setSelectedAnnouncement(null);
                        }}
                    >
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

                <div className="dashboard-announcements-sidbar-list">
                    {announcements?.length > 0 ? announcements.map(announcement => (
                        <div
                            key={announcement._id}
                            className={`dashboard-announcement-side-item ${selectedAnnouncement?._id === announcement._id ? 'active' : ''}`}
                            onClick={() => setSelectedAnnouncement(announcement)}
                        >
                            <div className="dashboard-announcement-icon">
                                <MDBIcon icon={announcement?.icon || 'bullhorn'} />
                            </div>
                            <div className="dashboard-announcement-preview">
                                <h5 className='m-0'>{announcement.title}</h5>
                                <p className="dashboard-announcement-date">
                                    {new Date(announcement.createdAt).toLocaleDateString("en-US", {
                                        month: "short",
                                        day: "numeric",
                                        year: "numeric"
                                    })}
                                </p>
                            </div>

                        </div>
                    )) :
                        <div className={`dashboard-announcement-side-item}`}>
                            <div className="dashboard-announcement-preview">
                                <p className="dashboard-announcement-date">
                                    No Announcement yet
                                </p>
                            </div>
                        </div>
                    }
                </div>
            </div>
            {/* )} */}

            {/* Announcement Detail Sidebar */}
            {selectedAnnouncement && (
                <div className="dashboard-announcement-detail-sidebar">
                    <div className="dashboard-sidebar-header">

                        <h5 className='m-0'>Announcement Details</h5>
           
                        <button
                            className="dashboard-back-button"
                            onClick={() => setSelectedAnnouncement(null)}
                        >
                            <i class="fa-solid fa-chevron-right"></i>
                            {/* <i className="fa-solid fa-chevron-rigth"></i> Back */}
                        </button>
                    </div>

                    <div className="dashboard-announcement-content">
                        <div className="dashboard-announcement-header p-3">
                            <div className="dashboard-announcement-icon-large">
                                <MDBIcon icon={selectedAnnouncement?.icon || 'bullhorn'} size="2x" />
                            </div>
                            <h4>{selectedAnnouncement.title}</h4>
                            <p className="dashboard-announcement-meta">
                                Posted: {new Date(selectedAnnouncement.createdAt).toLocaleDateString("en-US", {
                                    month: "long",
                                    day: "numeric",
                                    year: "numeric"
                                })}
                            </p>
                        </div>

                        <div
                            className="dashboard-announcement-body px-4"
                            dangerouslySetInnerHTML={{ __html: selectedAnnouncement.description }}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default ViewAnnouncement
